import { ref } from 'vue';
export function useDataGridOptions(props) {
    /**
     * Options for the dataGrid
     */
    const options = ref({
        page: 1,
        itemsPerPage: props.options?.itemsPerPage ?? 10,
        sortBy: props.defaultSortOrder ? props.defaultSortOrder.map((s) => ({ key: s.key, order: s.order })) : [],
    });
    /**
     * Calculate the width of each skeleton cell based on Header
     * @param column
     */
    function calculateSkeletonWidth(column) {
        const columnWidth = Number.parseInt(column.minWidth ?? '');
        if (!columnWidth)
            return '50px';
        // Width is less than original to prevent jumping of headers.
        // If we create skeleton the same size, it applies some margins, which results the header to be more than this number
        // If we need to add some "dynamic" width, add some Random function here
        return `${columnWidth - 40}px`;
    }
    return {
        options,
        calculateSkeletonWidth,
    };
}
